import React, { useState, useEffect } from "react";
import fullLogo from '../images/slots-full.png';
import { authenticationService } from "./../services";
import GoogleSSO from '../components/GoogleSSO/GoogleSSO';
import MicrosoftSSO from '../components/MicrosoftSSO/MicrosoftSSO';
import { microsoftEnabled } from '../authConfig';
import { MainLogo } from "../components/Page/MainPageStyles";
import CallVolume from "../components/Graphs/CallVolume";
import CallStats from "../components/Graphs/CallStats";
import ChatStats from "../components/Graphs/ChatStats";

export const HomePath = "/";

function Home() {
  const [ loggedIn, setLoggedIn ] = useState(authenticationService.currentUserValue);

  useEffect(() => {
    authenticationService.currentUser.subscribe(x => {
      setLoggedIn(authenticationService.currentUserValue);
    });
  });

  if (loggedIn) {

    return (
      <div>
        {/* <MainLogo className={`${logoClass}`} src={fullLogo}/> */}
        <CallStats />
        <ChatStats />
        <CallVolume />
      </div>
    );
  }

  return (
    <div style={{backgroundColor: "var(--color-white)", margin: "auto", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "10px"}}>
      <GoogleSSO/>
      {microsoftEnabled && <MicrosoftSSO/>}
    </div>
  );
}

export default Home;